var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrevious(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.22229 6.7179C3.08013 6.57738 3.00018 6.38674 3 6.1879V5.8079C3.00233 5.60948 3.08196 5.41962 3.22229 5.2779L8.41578 0.147899C8.51064 0.0532428 8.63977 0 8.77448 0C8.90918 0 9.03831 0.0532428 9.13317 0.147899L9.85056 0.857899C9.9456 0.950063 9.99916 1.07621 9.99916 1.2079C9.99916 1.33959 9.9456 1.46574 9.85056 1.5579L5.35425 5.9979L9.85056 10.4379C9.9462 10.5318 10 10.6596 10 10.7929C10 10.9262 9.9462 11.054 9.85056 11.1479L9.13317 11.8479C9.03831 11.9426 8.90918 11.9958 8.77448 11.9958C8.63977 11.9958 8.51064 11.9426 8.41578 11.8479L3.22229 6.7179Z",
    fill: "#98A3B3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/media/previous.05bd9f60c576b912d6ff171400d5ffc8.svg";
export { ForwardRef as ReactComponent };